export default __webpack_public_path__ + "static/media/Silver_1_Rank.fc97b398.png";